app.ui.registerUi('videoInput', function (app) {
    var helpers = app.helpers.funcs;
	return {
	    implementationExists: function () {
			return jQuery.fn.jdaVideoInput ? true : false;
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded([RESOURCE_NAME__DOM, RESOURCE_NAME__YOUTUBE])) {
                this.init();
            }
        },
        init: function ($scope) {
		    if (!this.implementationExists()) return;
		    var $elems = helpers.resolveScope('input.jda-video-input-seed', $scope);
			$elems.jdaVideoInput();
        }
	};
});
